import { stringifyUnknownValue } from "@/utils/stringifyUnknownValue"

export const parseOptionalFloat = (value: unknown): number | undefined => {
  const parsed = Number.parseFloat(stringifyUnknownValue(value))
  return Number.isFinite(parsed) ? parsed : undefined
}

export const parseOptionalInt = (value: unknown): number | undefined => {
  const parsed = Number.parseInt(stringifyUnknownValue(value), 10)
  return Number.isFinite(parsed) ? parsed : undefined
}

export const jsonMetadataToEditableString = (value: unknown): string => {
  if (value === undefined || value === null || value === "") {
    return ""
  }
  if (typeof value === "string") {
    return value
  }
  try {
    return JSON.stringify(value, null, 2)
  } catch {
    return ""
  }
}
